import { useAuth } from '@/Hooks/Company/useAuth'

export function useFeatureFlags() {
  const { authCompany } = useAuth()

  const featureFlags = authCompany.value.feature_flags

  function hasFeatureFlag(flag) {
    return featureFlags.includes(flag)
  }

  return {
    featureFlags,
    hasFeatureFlag
  }
}
